import './ControlActionModalContent.css';

import ModalBody from './components/ModalBody/ModalBody';
import { useTranslate } from '../../../hooks/context/useTranslate';
import { useModalKeyboard } from '../../../hooks/shortcuts/useModalKeyboard';
import Button from '../../Button/Button';

export interface ControlActionModalProps {
  type: 'danger' | 'default';
  header: string;
  text: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ControlActionModalContent = ({
  type,
  header,
  text,
  onConfirm,
  onCancel,
}: ControlActionModalProps) => {
  const { t } = useTranslate();

  useModalKeyboard({ onEnter: onConfirm, onEscape: onCancel });

  return (
    <ModalBody
      className={`control-action-modal-${type}`}
      header={header}
      text={text}
      buttons={
        <>
          <Button
            color={type === 'default' ? 'primary' : type}
            onClick={onConfirm}
          >
            {t('control.modal.confirm')}
          </Button>
          <Button color="light" fill="solid" onClick={onCancel}>
            {t('control.modal.cancel')}
          </Button>
        </>
      }
    />
  );
};

export default ControlActionModalContent;
